import constate from "constate"
import { useEffect, useState } from "react"
import { Url } from "utils/hooks/usePalletRouter"
import { FormikValues, useFormikContext } from "formik"

const [OnboardingModalProvider, useOnboardingModal] = constate(() => {
    const [isOpen, setIsOpen] = useState(false)
    const [routeAfterSubmit, setRouteAfterSubmit] = useState<Url | undefined>(
        undefined
    )
    const [email, setEmail] = useState<string | undefined>(undefined)
    const [password, setPassword] = useState<string | undefined>(undefined)

    const clearFields = () => {
        setEmail(undefined)
        setPassword(undefined)
    }

    const showModal = () => {
        setIsOpen(true)
        clearFields()
    }
    const hideModal = () => {
        setIsOpen(false)
        clearFields()
    }

    return {
        isOpen,
        setIsOpen,
        routeAfterSubmit,
        setRouteAfterSubmit,
        showModal,
        hideModal,
        email,
        setEmail,
        password,
        setPassword,
    }
})

const useSyncAuthFieldsFromFormik = () => {
    const { values } = useFormikContext<FormikValues>()
    const { setEmail, setPassword } = useOnboardingModal()
    useEffect(() => {
        setEmail(values.email)
        setPassword(values.password)
    }, [values, setEmail, setPassword])
}

export { OnboardingModalProvider, useSyncAuthFieldsFromFormik }
export default useOnboardingModal
